import React, { useEffect, useRef, useState } from "react";
import "./DepositAmount.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faUpload } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  DepositeAmount,
  DepositeAmountWithGateway,
  DepositeImbGateway,
  GetAllDepositHistory,
} from "../../../features/wallet/slice";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { GETAuthLogin } from "../../../features/auth/Slice";
import { Form } from "react-bootstrap";
import { AppSetup, GetPaymentQr } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import USDT_Tabs from "./usdt-tabs/USDT_Tabs";
// import useRazorpay from "react-razorpay";

const amounts = ["100", "200", "300", "400", "500", "1K", "2K", "3K", "5K"];

function DepositAmount() {
  const dispatch = useDispatch();

  // ✅ TAB STATE
  const [activeTab, setActiveTab] = useState("gateway");
  // const [Razorpay] = useRazorpay();

  const [selectedAmount, setSelectedAmount] = useState("");
  const [preview, setPreview] = useState(null);
  const [depositFile, setDepositFile] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [depositFileError, setDepositFileError] = useState("");
  const currentAmountRef = useRef(null);

  const appSetup = useSelector((state) => state.common.app_setup);
  const payment_qr = useSelector((state) => state.common.payment_qr);

  useEffect(() => {
    dispatch(AppSetup());
    dispatch(GetPaymentQr());
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      amount: "",
      utr_number: "",
    },
  });

  const inputValue = watch("amount");

  const handleAmountClick = (amt) => {
    const value = amt.includes("K") ? parseInt(amt) * 1000 : amt;
    setSelectedAmount(amt);
    setValue("amount", value, { shouldValidate: true });
  };

  const clearForm = () => {
    setSelectedAmount("");
    setPreview(null);
    setDepositFile(null);
    setDepositFileError("");
    reset({ amount: "", utr_number: "" });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDepositFile(file);
      setPreview(URL.createObjectURL(file));
      setDepositFileError("");
    }
  };

  const onSubmit = async (data) => {
    try {
      if (!depositFile && activeTab === "qr") {
        setDepositFileError("Please upload deposit proof receipt");
        return;
      }
      setDepositFileError("");

      const formData = new FormData();
      formData.append("amount", data.amount);
      formData.append("utr_number", data.utr_number);
      if (depositFile) formData.append("image", depositFile);

      const res = await dispatch(DepositeAmount(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        clearForm();
        setModalMessage(
          res?.payload?.data || "Deposit request submitted successfully",
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);

        await dispatch(GETAuthLogin());
        await dispatch(GetAllDepositHistory());
      } else {
        setModalMessage(
          res?.payload?.errors || "Deposit failed. Please try again",
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Deposit error:", error);
    }
  };

  // const handleGatewaySubmit = (data) => {
  //   currentAmountRef.current = data.amount;
  //   handleRazorpay(data.amount);
  // };

  const handleGatewaySubmit = (data) => {
    currentAmountRef.current = data.amount;
    handleRazorpay(data.amount);
  };

  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Om TApovan",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await onDepositSubmit(res.razorpay_payment_id);
      },
      prefill: {
        name: "Prajwal Vaychal",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    // const rzpay = new Razorpay(options);
    // rzpay.open();
  };

  const onDepositSubmit = async (razorpay_payment_id) => {
    try {
      const formData = new FormData();
      formData.append("payment_id", razorpay_payment_id);
      formData.append("amount", currentAmountRef.current);

      const res = await dispatch(DepositeAmountWithGateway(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        clearForm();
        setModalMessage(res?.payload?.data);
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        await dispatch(GETAuthLogin());
        console.log("Deposit successful:", res?.payload?.data);
      } else if (res.meta?.requestStatus === "rejected") {
        setModalShow(true);
        setModalMessage(res?.payload?.errors || "Deposit failed.");
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        console.error("Deposit rejected:", res?.payload?.errors);
      }
    } catch (error) {
      console.error("Deposit error:", error);
    }
  };

  const onIMBDeposit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("amount", data?.amount);
      const res = await dispatch(DepositeImbGateway(formData));

      console.log({ DepositeImbGateway: res });

      if (res.meta?.requestStatus === "fulfilled") {
        const paymentUrl = res?.payload?.data?.payment_url;
        if (paymentUrl) {
          // Redirect in the same tab
          // window.location.href = paymentUrl;

          // OR open in a new tab
          window.open(paymentUrl, "_blank");
        }
        // clearForm();
        // setModalMessage(res?.payload?.data);
        // setModalShow(true);
        // setTimeout(() => {
        //   setModalShow(false);
        // }, 3000);
        // await dispatch(GETAuthLogin());
        console.log("Deposit successful:", res?.payload?.data);
      } else if (res.meta?.requestStatus === "rejected") {
        setModalShow(true);
        setModalMessage(res?.payload?.errors || "Deposit failed.");
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        console.error("Deposit rejected:", res?.payload?.errors);
      }
    } catch (error) {
      console.error("Deposit error:", error);
    }
  };

  const onUSDTDeposit = async () => {
    console.log("ooooooooooooooo");

    try {
      setModalShow(true);
      setModalMessage(
        "This feature is currently unavailable. Please try again later.",
      );
      setTimeout(() => {
        setModalShow(false);
        setModalMessage("");
      }, 3000);
    } catch (error) {
      console.error("Deposit error:", error);
    }
  };

  return (
    <div className="deposit_amount deposit_card_box Modify_Bank_Information">
      <div className="wallet_card">
        <div className="wallet_buttons">
          <button
            className={`wallet_btn ${activeTab === "gateway" ? "active" : ""}`}
            onClick={() => setActiveTab("gateway")}
          >
            UPI / Card / Net Banking
          </button>

          <button
            className={`wallet_btn ${activeTab === "qr" ? "active" : ""}`}
            onClick={() => setActiveTab("qr")}
          >
            Pay & Upload Receipt
          </button>

          <button
            className={`wallet_btn ${activeTab === "usdt" ? "active" : ""}`}
            onClick={() => setActiveTab("usdt")}
          >
            USDT
          </button>
        </div>
      </div>

      {activeTab === "gateway" && (
        <div className="card_box">
          <div className="section_header">
            <span className="icon_box">
              <FontAwesomeIcon icon={faBook} />
            </span>
            <h4>Deposit Amount</h4>
          </div>

          <form onSubmit={handleSubmit(onIMBDeposit)} noValidate>
            <div className="amount_grid">
              {amounts.map((amt, index) => (
                <button
                  key={index}
                  type="button"
                  className={`amount_btn ${
                    selectedAmount === amt ? "active" : ""
                  }`}
                  onClick={() => handleAmountClick(amt)}
                >
                  ₹ {amt}
                </button>
              ))}
            </div>

            <button
              type="submit"
              className={`amount_btn submit_btn mt-3 w-100 ${
                inputValue ? "active" : ""
              }`}
              disabled={isSubmitting || !inputValue}
            >
              {isSubmitting ? "Processing..." : "Deposit"}
            </button>
          </form>
        </div>
      )}

      {activeTab === "qr" && (
        <div className="card_box">
          <div className="scanner_img_holder">
            <Swiper
              modules={[Autoplay, Pagination]}
              slidesPerView={1}
              spaceBetween={20}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{ clickable: true }}
            >
              {payment_qr?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="scanner_img_holder">
                    <img
                      src={IDS.IMG_URL + item.image}
                      className="scanner_img"
                      alt={`QR ${index + 1}`}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="section_header">
            <span className="icon_box">
              <FontAwesomeIcon icon={faBook} />
            </span>
            <h4>Deposit Amount</h4>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className="amount_grid">
              {amounts.map((amt, index) => (
                <button
                  key={index}
                  type="button"
                  className={`amount_btn ${
                    selectedAmount === amt ? "active" : ""
                  }`}
                  onClick={() => handleAmountClick(amt)}
                >
                  ₹ {amt}
                </button>
              ))}
            </div>
            <Form.Group className="form-group field_holder mb-3">
              <Form.Label>
                Please enter an amount{" "}
                <span className="mandatory_estrics">*</span>
              </Form.Label>

              <div className="amount_input_box">
                <span className="currency">₹</span>
                <input
                  type="number"
                  min="100"
                  max="50000"
                  placeholder="₹100 - ₹50,000"
                  {...register("amount", {
                    required:
                      activeTab === "qr" ? "Please enter an amount" : false,
                    min: { value: 100, message: "Minimum ₹100" },
                    max: { value: 50000, message: "Maximum ₹50,000" },
                  })}
                  onChange={(e) => {
                    setSelectedAmount("");
                    setValue("amount", e.target.value, {
                      shouldValidate: true,
                    });
                  }}
                />
                <span className="clear_btn" onClick={clearForm}>
                  ✕
                </span>
              </div>

              {errors.amount && (
                <small className="text-danger">{errors.amount.message}</small>
              )}
            </Form.Group>{" "}
            <Form.Group className="form-group field_holder mb-3">
              {" "}
              <Form.Label>
                {" "}
                UTR Number <span className="mandatory_estrics">*</span>{" "}
              </Form.Label>{" "}
              <div className="">
                {" "}
                <Form.Control
                  type="text"
                  placeholder="Please enter UTR number"
                  {...register("utr_number", {
                    required:
                      activeTab === "qr" ? "UTR Number is required" : false,
                    minLength: {
                      value: 12,
                      message: "UTR must be at least 12 characters",
                    },
                    maxLength: {
                      value: 22,
                      message: "UTR must be at most 22 characters",
                    },
                  })}
                />{" "}
              </div>{" "}
              {errors.utr_number && (
                <small className="text-danger d-block mt-1">
                  {" "}
                  {errors.utr_number.message}{" "}
                </small>
              )}{" "}
            </Form.Group>
            <Form.Group className="form-group field_holder mb-3">
              <Form.Label>
                Deposit Proof Receipt{" "}
                <span className="mandatory_estrics">*</span>
              </Form.Label>
              <div className="upload_box">
                <input
                  type="file"
                  id="depositProof"
                  hidden
                  accept="image/*"
                  onChange={handleFileChange}
                />
                <label className="photo_label" htmlFor="depositProof">
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      className="uploaded_img_preview"
                    />
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faUpload} /> <span>Upload</span>
                    </>
                  )}
                </label>
              </div>
              {depositFileError && (
                <small className="text-danger d-block mt-1">
                  {depositFileError}
                </small>
              )}
            </Form.Group>
            <button
              type="submit"
              className={`amount_btn submit_btn w-100 ${
                inputValue ? "active" : ""
              }`}
              disabled={isSubmitting || !inputValue}
            >
              {isSubmitting ? "Processing..." : "Deposit"}
            </button>
          </form>
        </div>
      )}

      {activeTab === "usdt" && (
        // <div className="card_box">
        //   <div className="scanner_img_holder">
        //     <img
        //       src={IDS.IMG_URL + appSetup?.image}
        //       className="scanner_img"
        //       alt="QR"
        //     />
        //   </div>

        //   <div className="section_header">
        //     <span className="icon_box">
        //       <FontAwesomeIcon icon={faBook} />
        //     </span>
        //     <h4>Deposit Amount</h4>
        //   </div>

        //   <form onSubmit={handleSubmit(onUSDTDeposit)} noValidate>
        //     <Form.Group className="form-group field_holder mb-3">
        //       {" "}
        //       <Form.Label>
        //         {" "}
        //         Enter USDT Address<span className="mandatory_estrics">
        //           *
        //         </span>{" "}
        //       </Form.Label>{" "}
        //       <div className="">
        //         {" "}
        //         <Form.Control
        //           type="text"
        //           placeholder="Please enter USDT Address"
        //           {...register("wallet_address", {
        //             required:
        //               activeTab === "usdt" ? "USDT Address is required" : false,
        //             minLength: {
        //               value: 12,
        //               message: "USDT Address must be at least 12 characters",
        //             },
        //             maxLength: {
        //               value: 100,
        //               message: "USDT Address must be at most 100 characters",
        //             },
        //           })}
        //         />{" "}
        //       </div>{" "}
        //       {errors.wallet_address && (
        //         <small className="text-danger d-block mt-1">
        //           {" "}
        //           {errors.wallet_address.message}{" "}
        //         </small>
        //       )}{" "}
        //     </Form.Group>

        //     <Form.Group className="form-group field_holder mb-3">
        //       {" "}
        //       <Form.Label>
        //         {" "}
        //         Enter USDT Type<span className="mandatory_estrics">*</span>{" "}
        //       </Form.Label>{" "}
        //       <div className="">
        //         {" "}
        //         <Form.Control
        //           type="text"
        //           placeholder="Please enter USDT Type"
        //           maxLength={30}
        //           {...register("wallet_address_type", {
        //             required:
        //               activeTab === "usdt" ? "USDT Type is required" : false,
        //             maxLength: {
        //               value: 30,
        //               message: "USDT Type must be at most 30 characters",
        //             },
        //           })}
        //         />
        //       </div>{" "}
        //       {errors.wallet_address_type && (
        //         <small className="text-danger d-block mt-1">
        //           {" "}
        //           {errors.wallet_address_type.message}{" "}
        //         </small>
        //       )}{" "}
        //     </Form.Group>
        //     <Form.Group className="form-group field_holder mb-3">
        //       {" "}
        //       <Form.Label>
        //         {" "}
        //         Enter Amount<span className="mandatory_estrics">*</span>{" "}
        //       </Form.Label>{" "}
        //       <div className="">
        //         {" "}
        //         <Form.Control
        //           type="number"
        //           placeholder="Please enter Amount"
        //           onKeyDown={(e) =>
        //             ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
        //           }
        //           {...register("address_amount", {
        //             required:
        //               activeTab === "usdt" ? "Please enter an amount" : false,
        //             pattern: {
        //               value: /^\d+(\.\d{1,2})?$/,
        //               message: "Please enter a valid amount",
        //             },
        //             min: {
        //               value: 100,
        //               message: "Minimum ₹100",
        //             },
        //             max: {
        //               value: 50000,
        //               message: "Maximum ₹50,000",
        //             },
        //           })}
        //         />
        //       </div>{" "}
        //       {errors.address_amount && (
        //         <small className="text-danger d-block mt-1">
        //           {" "}
        //           {errors.address_amount.message}{" "}
        //         </small>
        //       )}{" "}
        //     </Form.Group>

        //     <button
        //       type="submit"
        //       className={`amount_btn submit_btn w-100 ${
        //         inputValue ? "active" : ""
        //       }`}
        //       disabled={isSubmitting}
        //     >
        //       {isSubmitting ? "Processing..." : "Deposit"}
        //     </button>
        //   </form>
        // </div>

        <USDT_Tabs />
      )}

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </div>
  );
}

export default DepositAmount;
